import React from 'react';

import './EmptyLayout.scss';
import { Button } from '@instinet-analytics/semantic-ui-components';

export function EmptyLayout(props: { openAddWidgetsModal: () => void }) {
    const { openAddWidgetsModal } = props;
    return (
        <div className="EmptyLayout">
            <div className="add-panel">
                <div className="title">Add widgets to your layout</div>
                <div className="subtitle">
                    Add a few widgets to visualise your orders and market data
                </div>

                <Button
                    className="add-widget-btn"
                    primary
                    onClick={openAddWidgetsModal}
                >
                    Add Widgets
                </Button>
            </div>
        </div>
    );
}
